import React from 'react';
export default (function (_ref) {
  var prefixCls = _ref.prefixCls,
      cancelText = _ref.cancelText,
      okText = _ref.okText,
      title = _ref.title,
      handleCancel = _ref.handleCancel,
      handleOk = _ref.handleOk,
      locale = _ref.locale;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__header")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__cancel"),
    onClick: handleCancel
  }, cancelText || locale.cancelText), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__title")
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__submit"),
    onClick: handleOk
  }, okText || locale.okText));
});